<template>
    <div ref="modal"
         :class="{ open: openClass }"
         :style="{ display: display }"
         :aria-hidden="!value"
         class="fullpage-modal primary-background secondary-text"
         role="dialog"
         aria-modal="true"
         @transitionend="onTransitionEnd()"
    >
        <slot name="header">
            <div class="fullpage-modal__header">
                <slot name="logo">
                    <logo disableFocus></logo>
                </slot>
                <button type="button"
                        class="d-none d-md-inline-block round-icon-button secondary-background"
                        :aria-label="closeLabel"
                        @click="close()"
                >
                    <span class="icon-close primary-text"></span>
                </button>
                <button type="button"
                        class="d-md-none round-icon-button primary-background"
                        :aria-label="closeLabel"
                        @click="close()"
                >
                    <span class="icon-close secondary-text"></span>
                </button>
                <logo disableFocus style="visibility: hidden;"></logo>
            </div>
        </slot>
        <div class="fullpage-modal__container py-5">
            <arrow-icon v-if="topIcon" direction="top"></arrow-icon>
            <div ref="contentContainer" class="fullpage-modal__content" @scroll="updateHeightAndPosition()">
                <slot></slot>
            </div>
            <arrow-icon v-if="bottomIcon" direction="bottom"></arrow-icon>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import ArrowIcon from './arrow-icon';
    import { updatePopupStateInBody } from '../popups';
    import { startDialogBehaviour, stopDialogBehaviour } from '../../utils/dialog-behaviour';
    import { translatedCloseLabel } from '../../utils/is-on-language';

    export default {
        components: {
            'arrow-icon': ArrowIcon,
        },
        watch: {
            value (value, prevValue) {
                if (value !== prevValue) {
                    const startStopDialog = value ? startDialogBehaviour : stopDialogBehaviour;
                    startStopDialog(this.$refs.modal);
                    updatePopupStateInBody(value);
                }

                if (value) {
                    this.display = 'block';
                    this.$nextTick(() => {
                        this.updateHeightAndPosition();
                    });
                }

                this.$nextTick(() => this.openClass = value);
            },
        },
        props: {
            value: {
                type: Boolean,
            },
            icons: {
                type: Boolean,
            },
        },
        data () {
            return {
                scrollHeight: 0,
                scrollPosition: 0,
                containerHeight: 0,
                display: 'none',
                openClass: false,
                closeLabel: translatedCloseLabel(),
            };
        },
        mounted () {
            this.updateHeightAndPosition();
            this.resizeWindowListener = () => {
                this.updateHeightAndPosition();
            };
            this.onBodyKeydown        = this.onBodyKeydown.bind(this);

            window.addEventListener('resize', this.resizeWindowListener);
            document.addEventListener('keyup', this.onBodyKeydown);
        },
        beforeDestroy () {
            if (this.resizeWindowListener) window.removeEventListener('resize', this.resizeWindowListener);
            stopDialogBehaviour(this.$refs.modal);
            document.removeEventListener('keyup', this.onBodyKeydown);
        },
        computed: {
            topIcon () {
                return this.icons && this.scrollHeight > 0 && this.scrollPosition > 0;
            },
            bottomIcon () {
                return this.icons && this.scrollHeight > 0 && this.scrollPosition + this.containerHeight < this.scrollHeight;
            },
        },
        methods: {
            close () {
                this.$emit('input', false);
            },
            updateHeightAndPosition () {
                const container      = this.$refs.contentContainer;
                const $container     = $(this.$refs.contentContainer);
                this.scrollHeight    = container.scrollHeight;
                this.containerHeight = $container.height();
                this.scrollPosition  = container.scrollTop;
            },
            onBodyKeydown (event) {
                if (event.key === 'Escape') {
                    this.close();
                }
            },
            onTransitionEnd () {
                if (!this.value) {
                    this.$nextTick(() => {
                        this.display = 'none';
                    });
                }
            },
        },
    };
</script>
